import { Controller } from "@hotwired/stimulus";
import { handleHttpResponse } from "../../utils/http_utils";
import { resolveTodo } from "../../todo_list/todo_resolver";
import { originalResponseFromTurboResponseEvent } from "../../utils/turbo_utils";

export default class extends Controller {
  static values = {
    todoId: Number,
  };

  onCreatedMessage(e) {
    handleHttpResponse({
      payload: originalResponseFromTurboResponseEvent(e),
      onSuccess: () => {
        setTimeout(() => {
          resolveTodo(this.todoIdValue);
        }, 1000);
      },
    });
  }
}
